import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { apiGet, apiPost, setToken, getToken, formatApiError } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!getToken()) { setUser(null); setLoading(false); return; }
    try {
      const { user } = await apiGet("/auth/me");
      setUser(user);
    } catch {
      setToken(null);
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const data = await apiPost("/auth/login", { email, password });
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };
  const register = async (payload) => {
    const data = await apiPost("/auth/register", payload);
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };
  const changePassword = async (current_password, new_password) => {
    const data = await apiPost("/auth/change-password", { current_password, new_password });
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };
  const logout = async () => {
    try { await apiPost("/auth/logout"); } catch {}
    setToken(null);
    setUser(null);
  };

  const value = {
    user, loading,
    isAuthenticated: !!user,
    isPending: !!user && user.status === "pending" && user.role !== "admin",
    isApproved: !!user && (user.role === "admin" || user.status === "approved"),
    isAdmin: !!user && user.role === "admin",
    mustChangePassword: !!user && user.must_change_password,
    refresh, login, register, changePassword, logout,
    formatApiError,
  };
  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export function useAuth() {
  const v = useContext(AuthCtx);
  if (!v) throw new Error("useAuth must be used within AuthProvider");
  return v;
}
